import { useState, useRef, useEffect } from 'react';
import { Box, Input, List, ListItem, Text, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

export default function MemberSelect({ members, value, onChange, placeholder = 'Rechercher un membre...' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selected = members.find(m => String(m.id) === String(value));

  useEffect(() => {
    if (selected) setQuery(`${selected.nom} ${selected.prenom} (${selected.matricule})`);
    else setQuery('');
  }, [value, members]);

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        if (selected) setQuery(`${selected.nom} ${selected.prenom} (${selected.matricule})`);
        else setQuery('');
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [selected]);

  const filtered = query.trim() === '' || (selected && query === `${selected.nom} ${selected.prenom} (${selected.matricule})`)
    ? members
    : members.filter(m => {
        const q = query.toLowerCase();
        return `${m.nom} ${m.prenom}`.toLowerCase().includes(q)
          || `${m.prenom} ${m.nom}`.toLowerCase().includes(q)
          || (m.matricule || '').toLowerCase().includes(q);
      });

  const handleSelect = (member) => {
    onChange(member.id);
    setQuery(`${member.nom} ${member.prenom} (${member.matricule})`);
    setOpen(false);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    onChange('');
    setOpen(true);
  };

  return (
    <Box ref={containerRef} position="relative">
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.400" />
        </InputLeftElement>
        <Input
          value={query}
          onChange={handleInputChange}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          autoComplete="off"
        />
      </InputGroup>

      {open && filtered.length > 0 && (
        <List
          position="absolute"
          zIndex={1000}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          boxShadow="md"
          maxH="220px"
          overflowY="auto"
          w="100%"
          mt={1}
        >
          {filtered.slice(0, 50).map(m => (
            <ListItem
              key={m.id}
              px={3}
              py={2}
              cursor="pointer"
              _hover={{ bg: 'green.50' }}
              onMouseDown={() => handleSelect(m)}
            >
              <Text fontSize="sm" fontWeight="medium">{m.nom} {m.prenom}</Text>
              <Text fontSize="xs" color="gray.500">{m.matricule}</Text>
            </ListItem>
          ))}
        </List>
      )}

      {open && filtered.length === 0 && (
        <Box
          position="absolute"
          zIndex={1000}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          boxShadow="md"
          w="100%"
          mt={1}
          px={3}
          py={2}
        >
          <Text fontSize="sm" color="gray.500">Aucun membre trouvé</Text>
        </Box>
      )}
    </Box>
  );
}
